import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { victoriaLogsApi } from './api';

export const VICTORIALOGS_QUERY_ANNOTATION = 'victorialogs.io/query';

export const entityVictoriaLogsContent = EntityContentBlueprint.make({
  name: 'logs',
  params: {
    path: '/logs',
    title: 'Logs',
    filter: entity =>
      Boolean(entity.metadata.annotations?.[VICTORIALOGS_QUERY_ANNOTATION]),
    loader: () =>
      import('./components/VictoriaLogsPage').then(module => (
        <module.VictoriaLogsPage />
      )),
  },
});

export const victoriaLogsPlugin = createFrontendPlugin({
  pluginId: 'victorialogs',
  title: 'VictoriaLogs',
  extensions: [victoriaLogsApi, entityVictoriaLogsContent],
});
